// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15RwW","label":"styles_label__9fNDg"};